<template>
    <div
        class="card shadow p-3 mb-2"
        style="min-width:300px">
        <div class="d-flex">
            <div class="flex-grow-1">
                Buchungsanfrage
            </div>
            <div v-if="!keep">
                <FontAwesomeIcon
                    icon="trash"
                    class="fa-lg text-danger pointer"
                    @click="removeBooking" />
            </div>
        </div>
        <div class="mt-2">
            <h4>{{ booking.title }}</h4>
        </div>
        <div v-if="booking && booking.start && booking.end">
            <small v-if="booking.all_day">
                {{ $d(booking.start, 'dateNumeric') }} - {{ $d(booking.end, 'dateNumeric') }}
            </small>
            <small v-else>
                {{ $d(booking.start, 'dateTimeNumeric') }} - {{ $d(booking.end, 'dateTimeNumeric') }}
            </small>
        </div>
        <div v-if="requestedResource">
            <small>An</small> <span>{{ requestedResource.title }}</span> <BaseTooltip content="Kostenpflichtig">
                <small>
                    <FontAwesomeIcon
                        v-if="requestedResource.chargeable"
                        icon="euro-sign" />
                </small>
            </BaseTooltip>
        </div>
    </div>
</template>

<script>

import resourceBookingsMixin from "@/mixins/resourceBookingsMixin";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: "BookingCard",
    components: {FontAwesomeIcon},
    mixins: [resourceBookingsMixin],
    props: {
        booking: {
            type: Object,
            required: true
        },
        keep: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        requestedResource() {
            return this.resources?.find(resource => resource.id === this.booking.resourceId)
        }
    },
    methods: {
        removeBooking() {
            this.removeRequestedBooking(this.booking.uuid)
        }
    }
}
</script>

<style scoped>
</style>
